const BasketActionTypes = {
    TOGGLE_BASKET_HIDDEN: 'TOGGLE_BASKET_HIDDEN',
    ADD_ITEM: 'ADD_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
    CLEAR_ITEM_FROM_BASKET: 'CLEAR_ITEM_FROM_BASKET'
};

export default BasketActionTypes;